import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { ReactComponent as ModalClose } from "../../images/modal_close.svg";
import {
    PARTICIPANT_TIME_INTRO,
    POLL_TYPE,
    TEXTBOX,
    USER_SETTINGS,
    POLL_LENGTH_SETTING_TEXT,
    POLL_LENGTH_SETTING_DESC,
    MODAL_CANCEL_TEXT,
    RELEASE,
    ATTENDANCE_LENGTH_SETTING_TEXT,
    ATTENDANCE_LENGTH_SETTING_DESC,
    RELEASE_ATTENDANCE,
    RELEASE_POLL_TEXT,
    MODAL_CLOSE_TEXT,
    BUTTON,
    POLL_TIME_LIMIT_TEXT,
    ACTIVITY_TYPE_PLACEHOLDER,
    ATTENDANCE,
    POLL_TEXT,
    COUNTDOWN_TIMER_LABEL,
    POLL_COUNTDOWN_TIMER_DESCRIPTION,
    ATTENDANCE_TIME_LIMIT_TEXT, RELEASE_ACTIVITY_OPTIONS_DESCRIPTION, DEFAULT_COUNT_DOWN_TIME_LIMIT,
} from "../../utils/constants";
import YuJaButton from "../standardization/YuJaButton";
import "./modal.css";
import classes from "../../pages/PPTPlugin/PPTPollsPage.module.css";
import settingsClasses from "../../pages/PlatformSetting/Settings.module.css";
import {deCapitalizeWord, } from "../../utils/helpers";

import TimeLimitInput from "../TimeLimitInput";
import {MINIMUM_COUNT_DOWN_SETTING_ERROR} from "../../utils/toast-message-constants";
import YuJaSwitch from "../standardization/YuJaSwitch";


export default function PollTimeLimitModal({show, setShow, pollData, handleShareAll, handleOpen, userSettings}) {
    const {poll={}, } = pollData;

    const { pollType} = poll;


    const [isSubmitting, setIsSubmitting] = useState(false);
    const [pollTimeLimit, setPollTimeLimit] = useState(
        pollType === POLL_TYPE.ATTENDANCE
            ? poll.attendanceDuration
            : poll.pollTimeLimit
    );
    const [isUnlimitedTime, setIsUnlimitedTime] = useState(poll.manualEnd === "true" || poll.manualEnd === true);
    const [pollCountDown, setPollCountDown] = useState(
        pollType !== POLL_TYPE.ATTENDANCE
            ? (!!poll.getReadyAllTimeLimit ? poll.getReadyAllTimeLimit : userSettings[USER_SETTINGS.POLL_COUNTDOWN])
            : 0
    );


    const handleSubmit = async () => {
        let timeLimit = isUnlimitedTime ? 0 : pollTimeLimit;

        setIsSubmitting(true);
        try {
            if (pollType === POLL_TYPE.ATTENDANCE) {
                await handleOpen(timeLimit);
            } else { // shareAll
                await handleShareAll(timeLimit, pollCountDown);
            }
            setShow(false);
        } finally {
            setIsSubmitting(false);
        }

    };

    return (
        <Modal
            show={show}
            dialogClassName="activity-options-modal"
            onHide={() =>  setShow(false)}
        >
            <Modal.Header
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <ModalClose
                    tabIndex={0}
                    role={BUTTON}
                    onClick={() => setShow(false)}
                    className="modal-close"
                    aria-label={MODAL_CLOSE_TEXT}
                />
                <Modal.Title
                    className="modal-title"
                    id="contained-modal-title-vcenter"
                    role={TEXTBOX}
                >
                    {pollType === POLL_TYPE.ATTENDANCE ? RELEASE_ATTENDANCE : RELEASE_POLL_TEXT}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={classes.column} style={{gap: 15}}>
                    <div className={classes.description}>
                        {RELEASE_ACTIVITY_OPTIONS_DESCRIPTION.replaceAll(
                            ACTIVITY_TYPE_PLACEHOLDER,
                            pollType === POLL_TYPE.ATTENDANCE
                                ? deCapitalizeWord(ATTENDANCE)
                                : deCapitalizeWord(POLL_TEXT)
                        )}
                    </div>
                    {pollType === POLL_TYPE.MERGED_POLL &&
                        <>
                            <div className={classes.row} style={{gap: 15}}>
                                <div className={classes.column}>
                                    <div className={settingsClasses.settingLabel}>{POLL_LENGTH_SETTING_TEXT}</div>
                                    <div className={settingsClasses.settingDescription}>{POLL_LENGTH_SETTING_DESC}</div>
                                </div>
                                <div style={{flex: 1}}/>
                                <YuJaSwitch
                                    aria-label={POLL_LENGTH_SETTING_TEXT}
                                    checked={isUnlimitedTime}
                                    onChange={checked => {
                                        if (!!checked) {
                                            setPollTimeLimit(0);
                                        } else {
                                            setPollTimeLimit(!!poll.pollTimeLimit ? poll.pollTimeLimit : userSettings[USER_SETTINGS.POLL_DURATION]);
                                        }
                                        setIsUnlimitedTime(checked);
                                    }}
                                />
                            </div>


                            {!isUnlimitedTime &&
                                <div className={classes.row} style={{gap: 20, alignItems: "end", marginTop: 15}}>
                                    <div className={classes.column} style={{flex: 1, minWidth: 0}}>
                                        <div className={settingsClasses.settingLabel}>{POLL_TIME_LIMIT_TEXT}</div>
                                        <span className={settingsClasses.settingDescription}>
                                                {PARTICIPANT_TIME_INTRO.replaceAll(
                                                    ACTIVITY_TYPE_PLACEHOLDER,
                                                    pollType === POLL_TYPE.ATTENDANCE
                                                        ? deCapitalizeWord(ATTENDANCE)
                                                        : deCapitalizeWord(POLL_TEXT)
                                                )}
                                            </span>
                                    </div>
                                    <TimeLimitInput
                                        timeLimit={pollTimeLimit}
                                        setTimeLimit={(timeLimit) => {
                                            setPollTimeLimit(timeLimit);
                                            if (!timeLimit) {
                                                setIsUnlimitedTime(true);
                                            }
                                        }}
                                        unit={"HH:MM"}
                                    />
                                </div>
                            }

                            <div className={classes.row} style={{marginTop: 20, gap: 20}}>
                                <div className={classes.column} style={{maxWidth: 500}}>
                                    <div className={settingsClasses.settingLabel}>{COUNTDOWN_TIMER_LABEL}</div>
                                    <div className={settingsClasses.settingDescription}>
                                        {POLL_COUNTDOWN_TIMER_DESCRIPTION}
                                    </div>
                                </div>
                                <div style={{flex: 1, minWidth: 0}}/>
                                <TimeLimitInput
                                    timeLimit={pollCountDown}
                                    setTimeLimit={(timeLimit) => {
                                        setPollCountDown(timeLimit);
                                    }}
                                    unit={"MM:SS"}
                                    minVal={DEFAULT_COUNT_DOWN_TIME_LIMIT}
                                    reachMinValErrorText={MINIMUM_COUNT_DOWN_SETTING_ERROR}
                                />
                            </div>

                        </>
                    }
                    {pollType === POLL_TYPE.ATTENDANCE &&
                        <>
                            <div className={classes.row} style={{gap: 15}}>
                                <div className={classes.column}>
                                    <div className={settingsClasses.settingLabel}>{ATTENDANCE_LENGTH_SETTING_TEXT}</div>
                                    <div
                                        className={settingsClasses.settingDescription}>{ATTENDANCE_LENGTH_SETTING_DESC}</div>
                                </div>
                                <div style={{flex: 1}}/>
                                <YuJaSwitch
                                    aria-label={ATTENDANCE_LENGTH_SETTING_TEXT}
                                    checked={isUnlimitedTime}
                                    onChange={checked => {
                                        if (!!checked) {
                                            setPollTimeLimit(0);
                                        } else {
                                            setPollTimeLimit(
                                                !!poll.attendanceDuration
                                                    ? poll.attendanceDuration
                                                    : userSettings[USER_SETTINGS.ATTENDANCE_DURATION]
                                            );
                                        }
                                        setIsUnlimitedTime(checked);
                                    }}
                                />
                            </div>
                            {!isUnlimitedTime &&
                                <div className={classes.row} style={{gap: 20, alignItems: "end", marginTop: 15}}>
                                    <div className={classes.column} style={{flex: 1, minWidth: 0}}>
                                        <div className={settingsClasses.settingLabel}>{ATTENDANCE_TIME_LIMIT_TEXT}</div>
                                        <span className={settingsClasses.settingDescription}>
                                            {PARTICIPANT_TIME_INTRO.replaceAll(
                                                ACTIVITY_TYPE_PLACEHOLDER,
                                                pollType === POLL_TYPE.ATTENDANCE
                                                    ? deCapitalizeWord(ATTENDANCE)
                                                    : deCapitalizeWord(POLL_TEXT)
                                            )}
                                        </span>
                                    </div>
                                    <TimeLimitInput
                                        timeLimit={pollTimeLimit}
                                        setTimeLimit={(timeLimit) => {
                                            setPollTimeLimit(timeLimit);
                                            if (!timeLimit) {
                                                setIsUnlimitedTime(true);
                                            }
                                        }}
                                        unit={"HH:MM"}
                                    />
                                </div>
                            }
                        </>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <YuJaButton type="secondary" onClick={() => setShow(false)}>{MODAL_CANCEL_TEXT}</YuJaButton>
                <YuJaButton disabled={isSubmitting} onClick={handleSubmit}>{RELEASE.trim()}</YuJaButton>
            </Modal.Footer>
        </Modal>
    );
}